//--------------------------------------------------- ย้ายแล้ว ไป FullScreendialogs ----------------------------------
import React, { createRef } from "react";
// import Alert from 'react-s-alert';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
// import { GetCorService, GetCorServicei } from '../_getjson.js';
import { GetCorServicei, genURL, gengetURLTEST, genURLTEST } from './../_getjson.js';
import axios from 'axios'
import { Nav, NavItem } from 'react-bootstrap';
import Snackbar from './../Components/Snackbar/Snackbar'
import ErrorIcon from '@mui/icons-material/ErrorOutlineRounded';
import { parseJwt } from '../parseJWT';
import { MenuItem } from 'react-bootstrap';
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded';
import SelectDatas from "../PopUp/SelectData"
import MaterialUIPickers from "../Components/CustomDatepicker/MaterialUIPickers"
import dateNumberFormatter from "../CustomFunction/Checknumber/FloatConvert.js";
import CustomInput from "../Components/CustomInput/CustomInput.js";
import UseAutocompletes from "../Components/CustomInput/UseAutocompletes.js";
require('./../_css/PopUpOther.css');

export default class SaveMoneyExp extends React.Component {
    constructor(props) {
        super(props);
        this.AmountPayable = React.createRef(0);
        this.AmountPayable1 = React.createRef(0);
        this.Balance = React.createRef(0);
        this.cashbalance = React.createRef(0);
        this.advanceamount = React.createRef(0);
        this.pettycashvalue = React.createRef(0);
        this.cchq = React.createRef();
        this.cchqcode = React.createRef();
        this.cchqvalue = React.createRef();
        this.cchqpaymentamount = React.createRef();
        this.cchqremark = React.createRef();
        this.payonbehalf = React.createRef();
        this.Bankamount = React.createRef(0);
        this.Bankexpend = React.createRef(0);
        this.Remark = React.createRef("");
        this.CustomerName = React.createRef();
        this._Otherincomeinput = React.createRef(0);
        this.Expensesinput = React.createRef(0);
        this.state = {
            activeKey: "0",
            Pform: this.props.pms.split("|")[0],
            PCash: this.props.pms.split("|")[1],
            Pcheck: this.props.pms.split("|")[2],
            PIncome: this.props.pms.split("|")[3],
            PExpens: this.props.pms.split("|")[4],
            siteCodeUser: "",
            EnbIncom: false,
            isLoading: true,
            EnbExpenses: false,
            autoClose: 3600,
            color: "warning",
            messagealert: "",
            defaultselect: "0",
            Bookno: "0",
            recchq: [],
            recheckeddata: [],
            placeholderpettycash: "กรอกรหัสสาขา...",
            submitbuttondisabled: false,
            choicemodelData: [],
            pettycashdefaultvalue: "",
            ploadding: false,
            typeActoin: "",
        }
    }

    checkpettycash = async (Pettycashcode) => {

        let url = "CSPETTYCASH/getAll?Code=" + Pettycashcode !== "" ? Pettycashcode : "N"
        console.log("checkpettycash", genURL(url));
        axios.get(genURL(url), { timeout: 3600 }).then((res) => {
            if (res.data) {
                this.setState({
                    pettycash: [res.data[0]['CODE'] + " | " + res.data[0]['MYNAMETH']],
                    pettycashcode: res.data[0]['CODE']
                })
            }
        }).catch(error => {
            console.log(error);
        });
    }
    componentDidMount() {
        try {
            if (this.props.recheckeddata.length > 0) {
                console.log("RecheckedDocno", this.props.recheckeddata[0].DOCNO);
                this.RecheckedData(this.props.recheckeddata)
            }
        } catch (error) {

        }
        this.loadpettycash("")

        this.setRow(10);
        this.setRowCredit(10);
        let wtax = 0
        if (this.props.Wtaxamount) {
            wtax = this.props.Wtaxamount
        }
        console.log("AmountPayable", this.props.AmountPayable);
        this.AmountPayable.current.value = Number(this.props.AmountPayable).toFixed(2);
        this.AmountPayable1.current.value = parseFloat(this.props.AmountPayable - wtax).toFixed(2)
        this.Balance.current.value = parseFloat(this.props.AmountPayable - wtax).toFixed(2)

        //กลุ่มเงินสด-------------------------
        if (this.props.datacash) { // !== 0 !== false !== undifend !=="" !== null
            //ยอดเงินสดจ่าย 
            this.cashbalance.current.value = this.props.datacash.cashbalance ? this.props.datacash.cashbalance : 0.00.toFixed(2);
            //เงินทดรองจ่าย 
            this.advanceamount.current.value = this.props.datacash.advanceamount ? this.props.datacash.advanceamount : 0.00.toFixed(2);
            //เงินสดย่อย 
            if (this.props.datacash.Pettycashcode) {
                // let url = "CSPETTYCASH/getAll?Code=" + this.props.datacash.Pettycashcode
                // console.log(genURL(url));
                // axios.get(genURL(url), { timeout: 3600 }).then((res) => {
                //     if (res.data) {

                //         this.setState({
                //             pettycash: [res.data[0]['CODE'] + " | " + res.data[0]['MYNAMETH']],
                //             pettycashcode: res.data[0]['CODE']
                //         })
                //     }
                // }).catch(error => {
                //     console.log(error);
                // });

                this.checkpettycash(this.props.datacash.Pettycashcode)
            }
            //ยอดเงินสดย่อย
            this.pettycashvalue.current.value = this.props.datacash.pettycashvalue ? this.props.datacash.pettycashvalue : 0.00.toFixed(2);
        } else {
            //ยอดเงินสดจ่าย 
            this.cashbalance.current.value = 0.00.toFixed(2);
            //เงินทดรองจ่าย 
            this.advanceamount.current.value = 0.00.toFixed(2);
            //ยอดเงินสดย่อย
            this.pettycashvalue.current.value = 0.00.toFixed(2);
        }
        //จ่ายเงินโอนผ่านบัญชี------------------------- 
        if (this.props.databank) {
            //เลขที่บัญชี
            this.setState({ Bookno: this.props.databank.Bookno })
            //ยอดเงินโอน
            this.Bankamount.current.value = this.props.databank.Bankamount ? this.props.databank.Bankamount : 0.00.toFixed(2);
            //ค่าธรรมเนียมจ่ายหักบัญชี
            this.Bankexpend.current.value = this.props.databank.Bankexpend ? this.props.databank.Bankexpend : 0.00.toFixed(2);
            //หมายเหตุการโอน
            this.Remark.current.value = this.props.databank.Remark ? this.props.databank.Remark : "";
        } else {
            //ยอดเงินโอน
            this.Bankamount.current.value = 0.00.toFixed(2);
            //ค่าธรรมเนียมจ่ายหักบัญชี
            this.Bankexpend.current.value = 0.00.toFixed(2);
        }
        //เช็คจ่าย-------------------------
        if (this.props.cchqs) {
            this.setState({ cchqs: this.props.cchqs })
        }
        //รายได้อื่นๆ-------------------------
        if (this.props.otherincome) {
            this.setState({ otherincome: this.props.otherincome })
            setTimeout(() => {
                this._Otherincomecal();
            }, 300);
        }
        //ค่าใช้จ่ายอื่นๆ-------------------------
        if (this.props.expenses) {
            this.setState({ expenses: this.props.expenses })
            setTimeout(() => {
                this.Expensescal();
            }, 300);
        }
        this._Otherincomeinput.current.value = 0.00.toFixed(2);
        this.Expensesinput.current.value = 0.00.toFixed(2);
        //this.CashReceipt.current.focus();
        this.setState({
            page: this.props.from,
            selectedpettycash: ""
        })
        let SITECODESTR = parseJwt(localStorage.getItem('Token'));
        this.setState({ siteCodeUser: SITECODESTR.User.SITECODE });
        setTimeout(() => {
            this.Calculate();
        }, 200);
    }

    RecheckedData = async (data) => {
        // console.log("data[0].PETTYCASH", data[0].PETTYCASHCODE);
        this.setState({ submitbuttondisabled: true, pettycashdefaultvalue: data[0].PETTYCASHCODE, typeActoin: "recheck" })
        console.log("RecheckedData", data);
        this.cashbalance.current.value = await data[0].CASHAMOUNT
        this.advanceamount.current.value = await data[0].ADVANCEPAY
        this.checkpettycash(data[0].PETTYCASHCODE)
        this.pettycashvalue.current.value = await data[0].PETTYCASH


        await this.setState({ Bookno: data[0].BOOKNO });
        this.Bankamount.current.value = data[0].BANKAMOUNT
        this.Bankexpend.current.value = data[0].BANKEXPEND
        this.Remark.current.value = data[0].BOOKDESC

        // load recchq 
        let url = "CSPAYCHQ/Search?Tablename=" + this.props.from + "&Docno=" + data[0].DOCNO

        console.log("genURL(url)", genURL(url))
        let rscchqData = await axios.get(genURL(url), { timeout: 3600 }).then((res) => {
            return res.data
        })
        await console.log("rscchq", rscchqData)
        let itemrscchq = []
        if (rscchqData.length > 0) {
            for (let index = 0; index < rscchqData.length; index++) {
                // const element = array[index];
                console.log("rscchq", rscchqData[index].CHEQUENO);
                itemrscchq[index] = {
                    C0: index + 1,
                    Chequeno: rscchqData[index].CHEQUENO,
                    Pk_chequeno: rscchqData[index].PK_CHEQUENO,
                    Chqamount: rscchqData[index].CHQAMOUNT,
                    Bankcode: rscchqData[index].BANKCODE,
                    Chqdate: rscchqData[index].DOCDATE,
                    Chqpay: rscchqData[index].CHQPAY,
                    Remark: rscchqData[index].REMARK,
                    payonbehalf: rscchqData[index].PAYCHQTO
                }
            }
        }
        await console.log("zzzzzzzzzzzzzzzzz", itemrscchq)

        await this.setState({ recchq: itemrscchq })
        // end chq start recincome 
        let urlCSINCOME = "CSRECINCOME/Search?Tablename=" + this.props.from + "&Docno=" + data[0].DOCNO
        console.log("genURL(url)", genURL(urlCSINCOME))
        let csrecincomData = await axios.get(genURL(urlCSINCOME), { timeout: 3600 }).then((res) => {
            return res.data
        })
        await console.log("csrecincomData", csrecincomData)
        let itemotherincome = []
        let Incomename = ""
        if (csrecincomData.length > 0) {
            for (let index = 0; index < csrecincomData.length; index++) {
                await this.loadIncomename(csrecincomData[index].INCOME).then((value => {
                    Incomename = value
                })),
                    itemotherincome[index] = {
                        C0: index + 1,
                        BTN: 'delect',
                        Incomecode: csrecincomData[index].INCOME,
                        Incomename: Incomename,
                        IncomeRemark: csrecincomData[index].REMARK,
                        IncomeAmount: csrecincomData[index].AMOUNT
                    }
            }
        }
        await this.setState({ otherincome: itemotherincome })
        await this._Otherincomecal()
        // end recincome start Expenses

        let urlCSRECEXPENSE = "CSRECEXPENSE/Search?Tablename=" + this.props.from + "&Docno=" + data[0].DOCNO
        console.log("genURL(url)", genURL(urlCSRECEXPENSE))
        let csreexpensesData = await axios.get(genURL(urlCSRECEXPENSE), { timeout: 3600 }).then((res) => {
            return res.data
        })
        await console.log("csreexpensesdata", csreexpensesData)
        let Expensesdata = []
        let expensesname = ""
        if (csreexpensesData.length) {
            for (var i = 0; i < csreexpensesData.length; i++) {

                await this.loadexpensesname(csreexpensesData[i].EXPENSE).then((value => {
                    expensesname = value
                })),

                    Expensesdata[i] = {
                        C0: i + 1,
                        Expensescode: csreexpensesData[i].EXPENSE, //0
                        Expensesname: expensesname,
                        Expensesamount: csreexpensesData[i].AMOUNT, //1
                        Expensesremark: csreexpensesData[i].REMARK,//2  
                        BTN: 'delect'
                    }
            }
            await this.setState({ expenses: Expensesdata })
            await this.Expensescal()
        }
    }
    // load Income name for recheck
    loadIncomename = async (datasearch) => {
        let url = "CSINCOME/GETCODESCSINCOME?Codes=" + datasearch

        var data_ = []
        console.log(genURL(url));
        let icomname = await axios.get(genURL(url), { timeout: 60000 }).then((res) => {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    return res.data[i].MYNAMETH
                }
            }
        })
        await console.log("icomname", icomname);
        return icomname
    }
    // load expenses name for recheck
    loadexpensesname = async (datasearch) => {
        let url = "CSEXPENSE/GETCODES?Codes=" + datasearch

        var data_ = []
        console.log(genURL(url));
        let expensesname = await axios.get(genURL(url), { timeout: 60000 }).then((res) => {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    return res.data[i].MYNAMETH
                }
            }
        })
        await console.log("expensesname", expensesname);
        return expensesname
    }


    setRowCredit = (count) => {
        var data = [];
        for (let i = 0; i <= count - 1; i++) {
            data[i] = { C0: i + 1, }
        }
        this.setState({ cchqs: data });
        this.cchqvalue.current.value = "0.00"
        this.cchqpaymentamount.current.value = "0.00"
    }
    setRow = (count) => {
        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = { C0: i + 1, BTN: 1 }
        }
        this.setState({ otherincome: data });

        var data = [];
        for (var i = 0; i <= count - 1; i++) {
            data[i] = { C0: i + 1, BTN: 1 }
        }
        this.setState({ expenses: data });
    }
    CashReceipt = (e) => {
        this.Calculate();
    }
    Calculate = (e) => {
        let cchqs = 0.00

        for (let index = 0; index < this.state.recchq.length; index++) {
            if (this.state.recchq[index].Chequeno) {
                cchqs += Number(this.state.recchq[index].Chqamount)
            }
        }
        var BalanceIn = 0.00
        if (this.state.page === "CSPURCHASE" || this.state.page === "CSARCNDEPOSIT" || this.state.page === "CSOTHEREXPENSE" || this.state.page === "CSSALERETREQ" || this.state.page === "CSPAYMENT") {
            // if (this.cashbalance.current.value && this.Bankamount.current.value && this.Bankexpend.current.value) {
            BalanceIn = (Number(this.AmountPayable1.current.value) + Number(this.Expensesinput.current.value)) -
                (Number(this.cashbalance.current.value) + Number(this.advanceamount.current.value) + Number(cchqs) + Number(this.pettycashvalue.current.value)
                    + Number(this.Bankamount.current.value) + Number(this._Otherincomeinput.current.value)) + Number(this.Bankexpend.current.value)
            // }
        }
        this.Balance.current.value = BalanceIn.toFixed(2);
    }
    OnSave = (e) => {
        if (this.Balance.current.value === "0.00") {
            //เงินสด 
            let pettycash = ""
            try {
                pettycash = this.state.selectedpettycash[0].CODE
            } catch (error) {
                console.log("pettycash OnSave:", error);
            }

            var pettycashvalue = Number(this.pettycashvalue.current.value);
            //โอน
            var Bookno = this.state.Bookno === "0" ? "" : this.state.Bookno;
            var Bankamount = Number(this.Bankamount.current.value)
            var Bankexpend = Number(this.Bankexpend.current.value)
            //เงินสด or เงินโอน
            let cash = []
            cash.push({
                Cashbalance: typeof this.cashbalance.current.value !== "undefined" ? Number(this.cashbalance.current.value) : 0, // ยอดเงินสดจ่าย
                Advanceamount: typeof this.advanceamount.current.value !== "undefined" ? Number(this.advanceamount.current.value) : 0,//เงินทดรองจ่าย
                Pettycashcode: pettycash,
                Pettycashvalue: typeof Number(this.pettycashvalue.current.value) !== "undefined" ? Number(this.pettycashvalue.current.value) : 0, //เงินสดย่อย
                //เงินโอน
                Bookno: this.state.Bookno === "0" ? "" : this.state.Bookno, // เลขบัญชี
                Bankamount: typeof Number(this.Bankamount.current.value) !== "undefined" ? Number(this.Bankamount.current.value) : 0,
                Bankexpend: typeof Number(this.Bankexpend.current.value) !== "undefined" ? Number(this.Bankexpend.current.value) : 0,
                Transferremark: typeof this.Remark.current.value !== "undefined" ? this.Remark.current.value : "",
            })
            //ยอดเงินรวมที่ต้องชำระ 
            var recchq = []
            var recchqdata = []

            for (let i = this.state.recchq.length - 1; i >= 0; i--) {
                if (this.state.recchq[i].Chequeno) {
                    // new JSON style
                    recchqdata[i] = {
                        Chequeno: this.state.recchq[i].Chequeno,
                        Bankcode: this.state.recchq[i].Bankcode,
                        Bankbranch: this.state.recchq[i].Bankbranch,
                        Chqamount: this.state.recchq[i].Chqamount,
                        Chqpay: this.state.recchq[i].Chqpay,
                        Remark: this.state.recchq[i].Remark,
                        Chqdate: this.state.recchq[i].Chqdate,
                        Pk_chequeno: this.state.recchq[i].Pk_chequeno,
                        Payonbehalf: this.state.recchq[i].payonbehalf
                    }
                    recchq.push(recchqdata[i])
                }
            }
            // new JSON style
            var csotherincomedata = []
            var csotherincome = []
            for (var i = 0; i < this.state.otherincome.length; i++) {
                if (this.state.otherincome[i].Incomecode) {
                    let IncomeRemarks = !this.state.otherincome[i].IncomeRemark ? "" : this.state.otherincome[i].IncomeRemark
                    csotherincomedata[i] = {
                        Incomecode: this.state.otherincome[i].Incomecode,
                        Incomename: this.state.otherincome[i].Incomename,
                        IncomeRemark: IncomeRemarks,
                        IncomeAmount: this.state.otherincome[i].IncomeAmount
                    }
                    csotherincome.push(csotherincomedata[i])
                }
            }
            let csexpenses = []
            let Expensesdata = []
            for (var i = 0; i < this.state.expenses.length; i++) {
                if (this.state.expenses[i].Expensescode) {
                    let Expensesremarks = !this.state.expenses[i].Expensesremark ? "" : this.state.expenses[i].Expensesremark

                    // new JSON style 
                    Expensesdata[i] = {
                        Expensescode: this.state.expenses[i].Expensescode, //0
                        Expensesname: this.state.expenses[i].Expensesname,
                        Expensesamount: this.state.expenses[i].Expensesamount, //1
                        Expensesremark: Expensesremarks//2  
                    }
                    csexpenses.push(Expensesdata[i])
                }
            }
            if (Bankamount > 0 && Bookno === "") {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเลือกบัญชีธนาคาร" })
                return
            } else if (Bankamount <= 0 && Bookno) {// !== 0 !== false !== undifend !=="" !== null
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณาเพิ่มยอดเงินโอน" })
                return
            } else if (pettycash !== "" && pettycashvalue < 1) {
                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกยอดเงินสดย่อย", })
                return
            } else if (pettycash === "" && pettycashvalue > 0) {

                this.setState({ opensnackbar: true })
                this.setState({ color: "warning" })
                this.setState({ icon: ErrorIcon })
                this.setState({ messagealert: "กรุณากรอกรหัสเงินสดย่อย" })
                return
            }
            else {
                if (this.state.Pform === "I" && Bankexpend > 0) {
                    this.setState({ opensnackbar: true })
                    this.setState({ color: "warning" })
                    this.setState({ icon: ErrorIcon })
                    this.setState({ messagealert: "ยอดไม่สมดุล" })
                } else {
                    this.props.get_PopUpSaveMoney(cash, recchq, csexpenses, csotherincome);
                    this.props.closePopup();
                }
            }
            // }
        } else {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ยอดเงินไม่สมดุล" })
        }
    }

    /*------------------------------------------------------------- AC3 -------------------------------------------------------------------*/
    otherincomeBTN(cell, row, enumObject, rowIndex) {
        var btn = row.BTN;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} align="center"
                    onClick={this.Switch_PopupOtherincome.bind(null)}>
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case "delect":
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} align="center" onClick={this.delectROW.bind(null, rowIndex)}>
                    <i className="far fa-trash-alt" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            default: btnShow = <i id={"Icon_row" + row.C0} style={{ fontSize: "10px", color: "#000" }} ></i>; break;
        }
        return (<div>{btnShow}</div>);
    }

    _Otherincomecal = () => {
        var OtherBat = 0;
        for (var i = 0; i < this.state.otherincome.length; i++) {
            if (this.state.otherincome[i].IncomeAmount) {
                OtherBat += parseFloat(this.state.otherincome[i].IncomeAmount);
            }
        }
        this._Otherincomeinput.current.value = OtherBat
        // .toFixed(2);
        this.Calculate();
    }
    delectROW = (row) => {
        var ROWDATA = this.state.otherincome;
        ROWDATA[row] = {
            C0: row + 1,
            BTN: 1
        }
        var j = 0;
        for (var i = 0; i < ROWDATA.length; i++) {
            if (ROWDATA[i].Incomecode) {
                ROWDATA[j] = ROWDATA[i];
                ROWDATA[j].C0 = j + 1;
                j++;
            }
        }
        for (var i = j; i < 10; i++) {
            ROWDATA[i] = { C0: i + 1, BTN: 1 }
        }
        this.setState({ otherincome: ROWDATA });
        this._Otherincomecal();
    }
    onAfterSaveCellotherincome = (row, cellName, cellValue) => {
        this._Otherincomecal();
        this.setState({ EnbIncom: false })
    }
    onRowClickIncom = (row) => {
        if (row.Incomecode) {
            this.setState({ EnbIncom: true })
        }
    }
    onRowClickExpenses = (row) => {
        if (row.Expensescode) {
            this.setState({ EnbExpenses: true })
        }
    }
    /*------------------------------------------------------------- AC4 -------------------------------------------------------------------*/
    expensesBTN(cell, row, enumObject, rowIndex) {
        var btn = row.BTN;
        var btnShow = "";
        switch (btn) {
            case 1:
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} align="center"
                    onClick={this.Switch_PopupExpenses.bind(null)}>
                    <i className="fas fa-search" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            case "delect":
                btnShow = <div id={"Icon_row" + row.C0} style={{ cursor: "pointer", fontSize: "14px" }} align="center" onClick={this.expensesDelectROW.bind(null, rowIndex)}>
                    <i className="far fa-trash-alt" style={{ paddingTop: "7px" }}></i>
                </div>;
                break;
            default: btnShow = <i id={"Icon_row" + row.C0} style={{ fontSize: "10px", color: "#000" }} ></i>; break;
        }
        return (<div>{btnShow}</div>);
    }
    Expensescal = (e) => {
        var _Expenses = 0;
        for (var i = 0; i < this.state.expenses.length; i++) {
            if (this.state.expenses[i].Expensesamount) {
                _Expenses += parseFloat(this.state.expenses[i].Expensesamount);
            }
        }
        this.Expensesinput.current.value = _Expenses.toFixed(2);
        this.Calculate();
    }
    expensesDelectROW = (row) => {
        var ROWDATA = this.state.expenses;
        ROWDATA[row] = {
            C0: row + 1,
            BTN: 1
        }
        var j = 0;
        for (var i = 0; i < ROWDATA.length; i++) {
            if (ROWDATA[i].Expensescode) {
                ROWDATA[j] = ROWDATA[i];
                ROWDATA[j].C0 = j + 1;
                j++;
            }
        }
        for (var i = j; i < 10; i++) {
            ROWDATA[i] = { C0: i + 1, BTN: 1 }
        }
        this.setState({ expenses: ROWDATA });
        this.Expensescal();
    }

    onAfterSaveCellExpenses = async (row, cellName, cellValue) => {

        if (cellName === "Expensesamount") {

            let chcknum = "0"
            await dateNumberFormatter(cellValue).then(res => {
                chcknum = res
            });

            this.state.expenses[row.C0 - 1].Expensesamount = await chcknum
            //    this.dateNumberFormatter(cellValue)
        }
        console.log("onAfterSaveCellExpenses cellName", cellName);
        console.log("onAfterSaveCellExpenses cellValue", cellValue);
        this.Expensescal();
        this.setState({ EnbExpenses: false })
    }

    SelectSetData = (data1, data2) => {
        switch (data1) {
            case "BOOKNO":
                console.log("SelectSetData", data2);
                this.setState({ Bookno: data2 });
                if (data2 === "0") {
                    this.Bankamount.current.value = "0.00"
                    this.Bankexpend.current.value = "0.00"
                    this.Remark.current.value = ""
                }
                this.CashReceipt()
                break;
            case "BOOKNO1":
                console.log(data2);
                this.setState({ cchqbookno: data2 });
                break;
            case "checkdate":
                console.log("SelectSetData checkdate", data2);
                break;
            case "Calendar":
                this.setState({ cchqdate: data2 });
                break;
            default: break;
        }
        // this.Calculate();
    }
    // ------------- เพิ่ม input เงินสดย่อย --------------------------------------
    onUseAutocompleteactivate = (val) => {
        console.log("onUseAutocompleteactivate", val);
        if (val === "pettycash") {
            //  this.loadpettycash(val)
        }
    }

    setvalue = async (e, type) => {
        console.log(e, "setvalue xxxxxxxxxxxxxxx", type);
        if (type === "pettycash") {
            // console.log(e, "xxxxxxxxxxxxxxx", type);
            this.setState({ selectedpettycash: e })
        }
    }

    loadpettycash = async (val) => {
        // for check loading data
        await this.setState({ typeLoad: val, isLoadingchoiceModel: "กำลังโหลดข้อมูลกรุณารอสักครู่...", ploadding: true })

        let item = []
        await axios.get(genURL('CSPETTYCASH/getAll?')).then(res => {
            console.log("loadpettycash", res);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    item.push({ CODE: res.data[index].CODE, MYNAMETH: res.data[index].CODE + ":" + res.data[index].MYNAMETH })
                }
            }
        })
        await this.setState({ choicemodelData: item, isLoadingchoiceModel: "", ploadding: false })
    }
    //---------------------- end input เงินสดย่อย --------------------------------------
    /*-------------------------------------------------------------------------------------------------------------------------------------*/
    _handleSearch = (query) => {
        this.setState({ isLoading: true });
        var _url = "";
        var _code = "";
        var _name = "";
        switch (this.state.chkfocus) {
            case "pettycash":
                _url = "CSPETTYCASH/getAll?";
                _code = "CODE";
                _name = "MYNAMETH";
                break;
        }
        console.log(genURL(_url));
        return GetCorServicei(_url, "").then(res => {
            if (res !== "error") {
                var element = [];
                for (let index = 0; index < res.data.length; index++) {
                    element.push(res.data[index][_code] + " | " + res.data[index][_name]);
                }
                this.setState({
                    isLoading: false,
                    options: element
                });
            }
            return "SS";
        });
    };
    _blurinput = () => {
        console.log(this.state.selectedpettycash);
        var _txtselect = "";
        var _code = "";
        switch (this.state.chkfocus) {
            case "status":
                _txtselect = "" + this.state.selectedstatus;
                _code = _txtselect.split("|");
                this.setState({ status: _code[0].trim() });
                break;
        }
    }

    checkinput = (e) => {
        switch (e.target.name) {
            case "cashbalance":
                if (this.cashbalance.current.value === "") {
                    this.cashbalance.current.value = "0"
                }
                break;
            case "advanceamount":
                if (this.advanceamount.current.value === "") {
                    this.advanceamount.current.value = "0"
                }
                break;
            case "pettycashvalue":
                if (this.pettycashvalue.current.value === "") {
                    this.pettycashvalue.current.value = "0"
                }
                break;
            case "Bankamount":
                if (this.Bankamount.current.value === "") {
                    this.Bankamount.current.value = "0"
                }
                break;
            case "Bankexpend":
                if (this.Bankexpend.current.value === "") {
                    this.Bankexpend.current.value = "0"
                }
                break;
            default:
                break;
        }

    }
    Switch_Check = () => {
        this.setState({ PopupCheck: !this.state.PopupCheck });
    }
    GetPopUpCheck = (data) => {
        console.log("data GetPopUpCheck", data);
        if (data) {
            this.cchq.current.value = data.CHEQUENO
            this.cchqcode.current.value = data.CHEQUENO
            this.setState({ cchqbookno: data.BOOKNO });
        }
        this.setState({ PopupCheck: !this.state.PopupCheck });
    }
    newCchq = () => {
        this.cchq.current.value = ""
        this.cchqcode.current.value = ""
        this.setState({ cchqbookno: "" })
        this.setState({ cchqdate: "" });
        this.cchqvalue.current.value = (0).toFixed(2);
        this.cchqpaymentamount.current.value = (0).toFixed(2);
        this.cchqremark.current.value = ""
        this.payonbehalf.current.value = ""
    }
    onRowClickRECCHQ = (row, col, id) => {
        this.setState({ id1: id })
        if (row.Chequeno !== "" && row.Chequeno !== undefined) {
            this.cchq.current.value = row.Chequeno
            this.cchqcode.current.value = row.Chequeno
            this.setState({ cchqbookno: row.Bankcode })
            this.setState({ cchqdate: row.Chqdate });
            this.cchqvalue.current.value = row.Chqpay
            this.cchqpaymentamount.current.value = row.Chqamount
            this.cchqremark.current.value = row.Remark
            this.payonbehalf.current.value = row.payonbehalf
        }
    }
    submitCchq = async () => {
        await console.log("submitCchq this.cchq.current.value", this.cchq.current.value)
        if (this.cchq.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "เลขที่เช็ค" })
            return
        } else if (this.state.cchqbookno === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "เลขที่บัญชี" })
            return
        }
        else if (this.state.cchqdate === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "เช็คลงวันที่" })
            return
        }
        else if (this.cchqvalue.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "มูลค่าเช็คจ่าย" })
            return
        }
        else if (this.cchqpaymentamount.current.value === "") {
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "ยอดชำระครั้งนี้" })
            return
        }
        await console.log("submitCchq this.state.recchq.count", this.state.recchq.length)
        var col = this.state.recchq
        var j = 0
        if (this.state.recchq.length > 0) {
            for (let i = this.state.recchq.length - 1; i >= 0; i--) {// หาจากล่างขึ้นบน  มาต่อตรงนี้
                if (this.state.recchq[i].Chequeno === this.cchq.current.value) {
                    j = i;
                    break
                } else {
                    j++;
                }
            }
        }
        col[j] = {
            C0: j + 1,
            Chequeno: this.cchq.current.value,
            Pk_chequeno: this.cchqcode.current.value,
            Chqamount: this.cchqpaymentamount.current.value,
            Bankcode: this.state.cchqbookno,
            Chqdate: this.state.cchqdate,
            Chqpay: this.cchqvalue.current.value,
            Remark: this.cchqremark.current.value,
            payonbehalf: this.payonbehalf.current.value,
        }
        await this.setState({ recchq: col })
        this.cchq.current.value = ""
        this.cchqcode.current.value = ""
        this.setState({ cchqbookno: "" })
        this.setState({ cchqdate: "" });
        this.cchqvalue.current.value = (0).toFixed(2);
        this.cchqpaymentamount.current.value = (0).toFixed(2);
        this.cchqremark.current.value = ""
        this.payonbehalf.current.value = ""
        this.Calculate()
    }
    delCchq = () => {
        var col = this.state.recchq
        var id = this.state.id1
        if (this.cchq.current.value && col[id].Chequeno) {
            this.cchq.current.value = ""
            this.cchqcode.current.value = ""
            this.setState({ cchqbookno: "" })
            this.setState({ cchqdate: "" });
            this.cchqvalue.current.value = (0).toFixed(2);
            this.cchqpaymentamount.current.value = (0).toFixed(2);
            this.cchqremark.current.value = ""
            this.payonbehalf.current.value = ""
            col[id].Chequeno = ""
            col[id].Pk_chequeno = ""
            col[id].Chqamount = ""
            col[id].Bankcode = ""
            col[id].Chqdate = ""
            col[id].Chqpay = ""
            col[id].Remark = ""
            col[id].payonbehalf = ""
            var NewCol = []
            var j = 0
            for (var i = 0; i < col.length; i++) {
                if (col[i].Chequeno) {
                    NewCol[j] = col[i]
                    NewCol[j].C0 = j + 1
                    j++;
                }
            }
            this.setState({ recchq: NewCol })
            setTimeout(() => {
                this.Calculate()
            }, 500);
        } else {
            // AlertPopup("Warning", "คุณยังไม่ได้เลือกข้อมูล");
            this.setState({ opensnackbar: true })
            this.setState({ color: "warning" })
            this.setState({ icon: ErrorIcon })
            this.setState({ messagealert: "คุณยังไม่ได้เลือกข้อมูล" })
        }
    }
    Switch_PopupFind = () => {
        this.setState({ PopupFind: !this.state.PopupFind });
    }
    onClick = (e) => {
        if (e.target.value && e.target.type === "number") {
            e.target.value = Number(e.target.value); e.target.select()
        }
    }
    onBlur = (e) => {
        if (e.target.value && e.target.type === "number") {
            e.target.value = parseFloat(e.target.value).toFixed(2)
            if (e.target.name === "cchqvalue") {
                this.cchqpaymentamount.current.value = parseFloat(e.target.value).toFixed(2)
            }
        }
    }
    onKey = (e) => {
        if (e.target.name === "cchqvalue" && e.key === 'Enter') {
            this.cchqpaymentamount.current.value = parseFloat(e.target.value).toFixed(2)
        }
    }
    render() {
        return (
            <div className='popup' onClick={this.onClick} onBlur={this.onBlur} onKeyPress={this.onKey}>
                {this.state.PopupFind ? <Find closePopup={this.Switch_PopupFind} Customer={this.props.Customer} /> : null}
                <div className='popup_inner' style={{ marginTop: '62px' }}>
                    {/* <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-at" > บันทึกจ่ายเงิน </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div> */}
                    <div className="DivPopupLeft" align="left">
                        <div className="col-xs-4 col-sm-4 col-lg-4 col-md-4">
                            <div className=""> ยอดรวมเงินที่ต้องชำระ : </div>
                            <input type="text" className="SaveMoneyInput Green Price " readOnly ref={this.AmountPayable} />
                            <input type="text" className="SaveMoneyInput hidden" readOnly ref={this.AmountPayable1} />
                        </div>
                        <div className="col-xs-4 col-sm-4 col-lg-4 col-md-4">
                            <div className=""> ยอดคงเหลือ : </div>
                            <input type="text" className="SaveMoneyInput Red Price" readOnly ref={this.Balance} />
                        </div>
                        <div className="col-xs-4 col-sm-4 col-lg-4 col-md-4">
                            <div className=""> - </div>
                            <input type="button" className="SaveMoneyInput" value="ตกลง" onClick={this.OnSave} disabled={this.state.submitbuttondisabled} />
                        </div>
                    </div>

                    <div className="DivPopupLeft col-xs-12 col-sm-12 col-lg-12 col-md-12" align="left">
                        <br />
                        <Nav bsStyle="tabs" activeKey={this.state.activeKey} className="Inventory" onSelect={k => { this.setState({ activeKey: k }) }}>
                            {this.state.PCash === "1" ? <NavItem eventKey="0" > เงินสด/เงินโอน </NavItem> : null}
                            {this.state.Pcheck === "1" ? <NavItem eventKey="1" > เช็คจ่าย </NavItem> : null}
                            {this.state.PIncome === "1" ? <NavItem eventKey="2" > รายได้อื่นๆ </NavItem> : null}
                            {this.state.PExpens === "1" ? <NavItem eventKey="3" > ค่าใช้จ่ายอื่นๆ </NavItem> : null}
                        </Nav>
                        <div className="SaveMoneySubDiv" hidden={this.state.activeKey === "0" ? false : true}>
                            <div className="row">
                            </div>
                            <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4 SaveMoneyGroupInput">
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon SaveMoneyAddon"> ยอดเงินสดจ่าย : </span>
                                    <input type="number" className="form-control Price" ref={this.cashbalance} name="cashbalance" onKeyUp={this.CashReceipt.bind(null)} onBlur={this.checkinput.bind(this)} />
                                    <span className="input-group-addon icon"><i className="fas fa-calculator"></i></span>
                                </div>
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon SaveMoneyAddon"> เงินทดรองจ่าย : </span>
                                    <input type="number" className="form-control Price " ref={this.advanceamount} name="advanceamount" onKeyUp={this.CashReceipt.bind(null)} /* disabled */ onBlur={this.checkinput.bind(this)} />
                                    <span className="input-group-addon icon"><i className="fas fa-calculator"></i></span>
                                </div>
                                <div className='input-group col-xs-12 col-sm-12 col-md-12 col-lg-12'  >

                                    {/* {this.state.typeActoin !== "recheck" ? */}
                                    <UseAutocompletes title={"เงินสดย่อย"} id={"pettycash"}
                                        datalist={this.state.choicemodelData}
                                        valueReturn={e => this.setvalue(e, "pettycash")}
                                        activate={_ => this.onUseAutocompleteactivate("pettycash")}
                                        placeholder={this.state.isLoadingchoiceModel}
                                        defaultvalue={this.state.pettycashdefaultvalue}
                                    />

                                    {/* <span className="input-group-addon SaveMoneyAddon"> เงินสดย่อย </span>
                                    <AsyncTypeahead
                                        {...this.state}
                                        id="my-typeahead-id"
                                        labelKey="pettycash"
                                        onChange={(selectedpettycash) => this.setState({ selectedpettycash, pettycash: "" })}
                                        onBlur={this._blurinput}
                                        selected={this.state.pettycash}
                                        onSearch={this._handleSearch}
                                        minLength={1}
                                        placeholder={this.state.placeholderpettycash}
                                        renderMenuItemChildren={(option, props) => (
                                            <MenuItem key={option} > {option} </MenuItem>
                                        )}
                                        onFocus={() => this.setState({ chkfocus: "pettycash" })}
                                    /> */}
                                </div>
                                {/* </div> */}
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon SaveMoneyAddon"> ยอดเงินสดย่อย : </span>
                                    <input type="number" className="form-control Price" ref={this.pettycashvalue} name="pettycashvalue" onKeyUp={this.CashReceipt.bind(null)} onBlur={this.checkinput.bind(this)} />
                                </div>
                            </div>
                            <div className="form-group col-xs-1 col-sm-1 col-lg-1 col-md-1  ">
                            </div>

                            <div className="form-group col-xs-6 col-sm-6 col-lg-6 col-md-6 SaveMoneyGroupInput">
                                <div className="title"> จ่ายเงินโอนผ่านบัญชี </div>

                                <SelectDatas
                                    origin="BOOKNO"  // ประเภท
                                    valueSelect={e => this.SelectSetData("BOOKNO", e)} // รับค่ากลับ
                                    title="เลขที่บัญชี"
                                    defaultselect={this.state.Bookno}// ค่าเริ่มต้นของ ประเภทราคา
                                    popup={true}
                                />
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon SaveMoneyAddon"> ยอดเงินโอน : </span>
                                    <input type="number" className="form-control " name="Bankamount" ref={this.Bankamount} onKeyUp={this.CashReceipt.bind(null)} onBlur={this.checkinput.bind(this)} />
                                    <span className="input-group-addon icon"><i className="fas fa-calculator"></i></span>
                                </div>
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon SaveMoneyAddon"> ค่าธรรมเนียมจ่ายหักบัญชี : </span>
                                    <input type="number" className="form-control" name="Bankexpend" ref={this.Bankexpend} onKeyUp={this.CashReceipt.bind(null)} onBlur={this.checkinput.bind(this)} />
                                    <span className="input-group-addon icon"><i className="fas fa-calculator"></i></span>
                                </div>
                                <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                    <span className="input-group-addon SaveMoneyAddon"> หมายเหตุการโอน : </span>
                                    <input type="text" className="form-control" ref={this.Remark} />
                                </div>
                            </div>
                        </div>
                        <div className="SaveMoneySubDiv" hidden={this.state.activeKey === "1" ? false : true}>
                            <div className="SubDiv1">
                                <BootstrapTable
                                    data={this.state.recchq}
                                    hover={true}
                                    options={{
                                        noDataText: "...",
                                        onRowClick: this.onRowClickRECCHQ,
                                    }}
                                >
                                    <TableHeaderColumn dataField='C0' isKey width="35" dataAlign="center"></TableHeaderColumn>
                                    <TableHeaderColumn dataField='Chequeno' editable={this.state.C1_editable} dataAlign="left" width="170" > <div align="center"> เลขที่เช็ค/ตั่วเงิน </div> </TableHeaderColumn>
                                    <TableHeaderColumn dataField='Chqamount' editable={false} dataAlign="left" width="230" > <div align="center"> ยอดชำระ </div> </TableHeaderColumn>
                                    <TableHeaderColumn
                                        // row="0" rowSpan="2"
                                        dataField='Bankbranch' width="230">Bankbranch</TableHeaderColumn>
                                    <TableHeaderColumn
                                        // row="0" rowSpan="2"
                                        dataField='Chqdate' width="230">Chqdate</TableHeaderColumn>
                                    <TableHeaderColumn
                                        // row="0" rowSpan="2"
                                        dataField='payonbehalf' width="230">payonbehalf</TableHeaderColumn>
                                    <TableHeaderColumn
                                        // row="0" rowSpan="2"
                                        dataField='Remark' width="230" >Remark</TableHeaderColumn>
                                    <TableHeaderColumn
                                        // row="0" rowSpan="2"
                                        dataField='Bankcode' width="230">Bankcode</TableHeaderColumn>
                                    <TableHeaderColumn
                                        // row="0" rowSpan="2"
                                        dataField='Chqpay' width="230">Chqpay</TableHeaderColumn>
                                </BootstrapTable>
                            </div>
                            <div className="SubDiv2">
                                <div className="form-group col-xs-12 col-sm-12 col-lg-12 col-md-12 SaveMoneyGroupInput">
                                    <div className="title"> รายละเอียด </div>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon SaveMoneyAddon"> เลขที่เช็ค : </span>
                                        <input type="text" className="form-control" ref={this.cchq} disabled />
                                        <input type="text" className="form-control hidden" ref={this.cchqcode} disabled />
                                        <span id="sitecode1" className="input-group-addon icon" onClick={() => { this.setState({ PopupCheck: !this.state.PopupCheck }) }}>
                                            <i> <ArrowDropDownRoundedIcon fontSize="small" /></i>
                                        </span>
                                    </div>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <SelectDatas
                                            origin="BOOKNO1"  // เลขที่บัญชี
                                            valueSelect={e => this.SelectSetData("BOOKNO1", e)} // รับค่ากลับ
                                            title="เลขที่บัญชี"
                                            defaultselect={this.state.cchqbookno}// ค่าเริ่มต้นของ เลขที่บัญชี
                                            popup={true}
                                        />
                                    </div>
                                    <MaterialUIPickers
                                        title="เช็คลงวันที่"
                                        DateValue={e => this.SelectSetData("Calendar", e)}
                                        defaultdate={this.state.cchqdate}
                                        popup={true} />
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon SaveMoneyAddon"> มูลค่าเช็คจ่าย : </span>
                                        <input type="number" className="form-control" name="cchqvalue" ref={this.cchqvalue} />
                                        <span className="input-group-addon icon"><i className="fas fa-calculator"></i></span>
                                    </div>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon SaveMoneyAddon"> ยอดชำระครั้งนี้: </span>
                                        <input type="number" className="form-control" ref={this.cchqpaymentamount} />
                                        <span className="input-group-addon icon"><i className="fas fa-calculator"></i></span>
                                    </div>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon SaveMoneyAddon"> หมายเหตุการจ่ายเช็ค : </span>
                                        <input type="text" className="form-control" ref={this.cchqremark} />
                                    </div>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon SaveMoneyAddon"> จ่ายในนาม : </span>
                                        <input type="text" className="form-control" ref={this.payonbehalf} />
                                    </div>
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <button className="SaveMoneySubBTN" onClick={this.newCchq}><i className="far fa-file-alt" > New </i></button>
                                        <button className="SaveMoneySubBTN" onClick={this.delCchq}><i className="fas fa-trash-alt" > Del </i></button>
                                        <button className="SaveMoneySubBTN" onClick={() => { this.setState({ PopupFind: !this.state.PopupFind }) }} ><i className="fas fa-search" > find </i></button>
                                        <button className="SaveMoneySubBTN" onClick={this.submitCchq} ><i className="fas fa-check" > OK </i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="SaveMoneySubDiv" hidden={this.state.activeKey === "2" ? false : true}>
                            <BootstrapTable
                                data={this.state.otherincome}
                                trClassName='trClassName'
                                tableHeaderClass='trClassName'
                                options={{
                                    noDataText: "...",
                                    onRowClick: this.onRowClickIncom,
                                }}
                                cellEdit={{ //แก้ไข
                                    mode: 'click',
                                    blurToSave: true,
                                    beforeSaveCell: this.onBeforeSaveCell,
                                    afterSaveCell: this.onAfterSaveCellotherincome,
                                }}
                                keyBoardNav={{ enterToEdit: true }}
                            >
                                <TableHeaderColumn dataField='C0' isKey width="35" dataAlign="center"></TableHeaderColumn>
                                <TableHeaderColumn dataField='Incomecode' editable={false} dataAlign="left" width="150" > <div align="center"> รหัสรายได้ </div> </TableHeaderColumn>
                                <TableHeaderColumn dataField='BTN' editable={false} dataAlign="left" width="35" dataFormat={this.otherincomeBTN.bind(this)}><div align="center"></div> </TableHeaderColumn>
                                <TableHeaderColumn dataField='Incomename' editable={false} dataAlign="left" width="150" > <div align="center"> ชื่อรายได้ </div> </TableHeaderColumn>
                                <TableHeaderColumn dataField='IncomeRemark' editable={this.state.EnbIncom} dataAlign="left" width="200" > <div align="center"> หมายเหตุ </div> </TableHeaderColumn>
                                <TableHeaderColumn dataField='IncomeAmount' editable={this.state.EnbIncom} dataAlign="left" width="100" > <div align="center"> จำนวนเงิน </div> </TableHeaderColumn>
                            </BootstrapTable>
                            <div className="row">
                                <div className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8 FromGroupPOPUP">
                                </div>
                                <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4 FromGroupPOPUP">
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon">รายได้รวมอื่นๆ : </span>
                                        <input type="number" className="form-control Price" ref={this._Otherincomeinput} />
                                        <span className="input-group-addon icon" onClick={this._Otherincomecal}><i className="fas fa-calculator"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="SaveMoneySubDiv" hidden={this.state.activeKey === "3" ? false : true}>
                            <BootstrapTable
                                data={this.state.expenses}
                                trClassName='trClassName'
                                tableHeaderClass='trClassName'
                                options={{
                                    noDataText: "...",
                                    onRowClick: this.onRowClickExpenses,
                                }}
                                cellEdit={{ //แก้ไข
                                    mode: 'click',
                                    blurToSave: true,
                                    beforeSaveCell: this.onBeforeSaveCell,
                                    afterSaveCell: this.onAfterSaveCellExpenses,
                                }}
                                keyBoardNav={{ enterToEdit: true }}
                            >
                                <TableHeaderColumn dataField='C0' isKey width="35" dataAlign="center"></TableHeaderColumn>
                                <TableHeaderColumn dataField='Expensescode' editable={false} dataAlign="left" width="150" > <div align="center"> รหัสค่าใช้จ่าย </div> </TableHeaderColumn>
                                <TableHeaderColumn dataField='BTN' editable={false} dataAlign="left" width="35" dataFormat={this.expensesBTN.bind(this)}><div align="center"></div> </TableHeaderColumn>
                                <TableHeaderColumn dataField='Expensesname' editable={false} dataAlign="left" width="150" > <div align="center"> ชื่อค่าใช้จ่าย </div> </TableHeaderColumn>
                                <TableHeaderColumn dataField='Expensesremark' editable={this.state.EnbExpenses} dataAlign="left" width="200" > <div align="center"> หมายเหตุ </div> </TableHeaderColumn>
                                <TableHeaderColumn dataField='Expensesamount' editable={this.state.EnbExpenses} dataAlign="left" width="100"  > <div align="center"> จำนวนเงิน </div> </TableHeaderColumn>
                            </BootstrapTable>
                            <div className="row">
                                <div className="form-group col-xs-8 col-sm-8 col-lg-8 col-md-8 FromGroupPOPUP">
                                </div>
                                <div className="form-group col-xs-4 col-sm-4 col-lg-4 col-md-4 FromGroupPOPUP">
                                    <div className="input-group col-xs-12 col-sm-12 col-lg-12 col-md-12">
                                        <span className="input-group-addon">รายได้รวมอื่นๆ : </span>
                                        <input type="number" className="form-control Price" ref={this.Expensesinput} />
                                        <span className="input-group-addon icon" onClick={this.Expensescal}><i className="fas fa-calculator"></i></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.PopupCheck ? <Cheque closePopup={this.Switch_Check} GetPopUpCheck={this.GetPopUpCheck} docno={"cxxxxx"} /> : null}
                {this.state.PopupOtherBat ? <Income closePopup={this.Switch_PopupOtherincome} /> : null}
                {this.state.PopupExpenses ? <Expenses closePopup={this.Switch_PopupExpenses} /> : null}
                <Snackbar place="br"
                    color={this.state.color}
                    icon={this.state.icon}
                    autoClose={this.state.autoClose}
                    message={this.state.messagealert}
                    open={this.state.opensnackbar}
                    closeNotification={() => { this.setState({ opensnackbar: false }) }}
                    close />
            </div>
        )
    }
    //------------------  รายได้รวมอื่นๆ หลังจากเลือก----------------------------------------
    Switch_PopupOtherincome = (data) => {
        console.log("Switch_PopupOtherincome", data)
        this.setState({ PopupOtherBat: !this.state.PopupOtherBat });
        if (data !== "") {
            var row = this.state.otherincome
            var j = 0;
            for (var i = this.state.otherincome.length - 1; i >= 0; i--) { if (!this.state.otherincome[i].Incomecode) { j = i; } }
            row[j] = {
                C0: j + 1,
                Incomecode: data.Incomecode,
                Incomename: data.Incomename,
                BTN: 'delect',
            }
            this.setState({ otherincome: row });
        }
    }
    //------------------------ end otherincome -----------------------------------------
    //-------------------------- expenses ----------------------------------------------
    Switch_PopupExpenses = (data) => {
        console.log("data Switch_PopupExpenses", data);
        this.setState({ PopupExpenses: !this.state.PopupExpenses });
        if (data !== "") {

            var row = this.state.expenses;
            var j = 0;
            for (var i = this.state.expenses.length - 1; i >= 0; i--) { if (!this.state.expenses[i].Expensescode) { j = i; } }

            row[j] = {
                C0: j + 1,
                Expensescode: data.Expensescode,
                Expensesname: data.Expensesname,
                BTN: 'delect',
            }
            this.setState({ expenses: row });
        }
    }
}
export class Find extends React.Component {
    constructor(props) {
        super(props);
        this.search = createRef();
        this.state = {
            MenuItem: []
        }
    }
    onSelectRow = (data) => {
        this.props.closePopup(data);
    }
    componentDidMount() {
        var url = "CSCHEQUEIN/GETCUSTOMER?Code=" + this.props.Customer
        var data_ = this.state.MenuItem;
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then((res) => {
            for (var i = 0; i < res.data.length; i++) {
                data_[i] = {
                    C0: i + 1,
                    Chequeno: res.data[i].CHEQUENO,
                    Bankname: res.data[i].BANKNAME
                }
                if (i === res.data.length - 1) {
                    this.setState({ MenuItem: data_ });
                }
            }
        }).catch(error => {
            console.log(error);
        });
    }
    render() {
        return (
            <div className="popup" onKeyPress={this.onKeyPress}>
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-at"> ค้นหาเช็ค </i></div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}><i className="fas fa-times"></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <BootstrapTable
                            data={this.state.MenuItem}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: "ไม่พบข้อมูล"
                            }}
                            hover condensed
                        >
                            <TableHeaderColumn dataField='C0' className="columnNumber" isKey width="35" dataAlign="center"></TableHeaderColumn>
                            <TableHeaderColumn dataField='Chequeno' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="100" >
                                <div align="center"> รหัส </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='Bankname' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" >
                                <div align="center"> รายการ </div>
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        )
    }
}
export class Income extends React.Component {
    constructor(props) {
        super(props);
        this.search = createRef();
        this.state = {
            MenuItem: [],
            selected: "0"
        }
    }
    onSelectRow = (data) => {
        this.props.closePopup(data);
    }
    componentDidMount() {
        var url = "CSINCOME/GETALLCSINCOME?";
        var data_ = this.state.MenuItem;
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then((res) => {
            for (var i = 0; i < res.data.length; i++) {
                data_[i] = {
                    C0: i + 1,
                    Incomecode: res.data[i].CODE,
                    Incomename: res.data[i].MYNAMETH
                }
                if (i === res.data.length - 1) {
                    this.setState({ MenuItem: data_ });
                }
            }
        });
    }
    loadData = async (datasearch) => {
        let url = ""
        if (this.state.selected === "0") {
            url = "CSINCOME/GETCODESCSINCOME?Codes=" + datasearch
        } else if (this.state.selected === "1") {
            url = "CSINCOME/GETNAMECSINCOME?Name=" + datasearch
        }
        var data_ = []
        console.log(genURL(url));
        await axios.get(genURL(url), { timeout: 60000 }).then((res) => {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    data_[i] = {
                        C0: i + 1,
                        Incomecode: res.data[i].CODE,
                        Incomename: res.data[i].MYNAMETH
                    }
                }
            }
        }).finally(_ => {
            this.setState({ MenuItem: [...data_] });
        }).catch(error => {
            console.log(error);
        });
    }
    onKeyPress = (e) => {
        if (e.target.name === "search" && e.key === "Enter") {
            this.loadData(this.search.current.value)
        }
    }
    render() {
        return (
            <div className="popup" onKeyPress={this.onKeyPress}>
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-at"> OtherBat </i></div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}><i className="fas fa-times"></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <div>
                            <div className="form-inline">
                                <div className="form-group mb-2">
                                    <input type='radio' id='Choice-1' name='myRadio' value='0'
                                        checked={this.state.selected === "0"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;</span>
                                    <input type='radio' id='Choice-2' name='myRadio' value='1'
                                        checked={this.state.selected === "1"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;</span>
                                </div>
                            </div>
                        </div>
                        <div className="input-group width-grop" >
                            <input type="text" className="form-control" placeholder="กรอกคำค้นหา" ref={this.search} name="search" />
                            <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={() => { this.loadData(this.search.current.value) }}></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.componentDidMount() }}></i></span>
                        </div>
                        <BootstrapTable
                            data={this.state.MenuItem}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: this.state.loadding
                            }}
                            hover condensed
                        >
                            <TableHeaderColumn dataField='C0' className="columnNumber" isKey width="35" dataAlign="center"></TableHeaderColumn>
                            <TableHeaderColumn dataField='Incomecode' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="100" >
                                <div align="center"> รหัส </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='Incomename' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" >
                                <div align="center"> รายการ </div>
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        )
    }
}

// ------------------------------ เลือกเช็ค----------------------------------
export class Cheque extends React.Component {
    constructor(props) {
        super(props);
        this.search = createRef();
        this.state = {
            MenuItem: [],
            selected: "0"
        }
    }
    onSelectRow = (data) => {
        this.props.GetPopUpCheck(data);
    }
    componentDidMount() {


        var url = "CSCHQBOOK/GETCSCHQBOOK?";
        var data_ = this.state.MenuItem;
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then((res) => {
            //  console.log("res xxxxxxxxxxxxxxxxxxxxxx", res.data);
            for (var i = 0; i < res.data.length; i++) {
                data_[i] = {
                    C0: i + 1,
                    CHEQUENO: res.data[i].CHEQUENO,
                    BANKNAME: res.data[i].BANKNAME,
                    BANKBRANCHCODE: res.data[i].BANKBRANCHCODE,
                    BOOKNO: res.data[i].BOOKNO,
                    PK_CHEQUENO: res.data[i].PK_CHEQUENO
                }
                if (i === res.data.length - 1) {
                    this.setState({ MenuItem: data_ });
                }
            }
        });
    }

    render() {
        return (
            <div className="popup" onKeyPress={this.onKeyPress}>
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-at"> เลือกเช็คจ่าย-SELCHBOOK </i></div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}><i className="fas fa-times"></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <BootstrapTable
                            data={this.state.MenuItem}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: this.state.loadding
                            }}
                            hover condensed
                        >

                            <TableHeaderColumn dataField='C0' className="columnNumber" isKey width="35" dataAlign="center"></TableHeaderColumn>
                            <TableHeaderColumn dataField='CHEQUENO' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="100" >
                                <div align="center"> รหัส </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='BANKNAME' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" >
                                <div align="center"> รายการ </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='BANKBRANCHCODE' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" >
                                <div align="center"> สาขา </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='BOOKNO' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" >
                                <div align="center"> สมุดบัญชี </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='PK_CHEQUENO' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200"  >
                                <div align="center"> </div>
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        )
    }
}
export class Expenses extends React.Component {
    constructor(props) {
        super(props);
        this.search = createRef();
        this.state = {
            MenuItem2: [],
            selected: "0"
        }
    }
    onSelectRow = (data) => {
        this.props.closePopup(data);
    }
    componentDidMount() {
        var url = "CSEXPENSE/GETALL?";
        var data_ = this.state.MenuItem2;
        console.log(genURL(url));
        axios.get(genURL(url), { timeout: 60000 }).then((res) => {
            if (res.data === undefined) {
                return
            }
            for (var i = 0; i < res.data.length; i++) {
                data_[i] = {
                    C0: i + 1,
                    Expensescode: res.data[i].CODE,
                    Expensesname: res.data[i].MYNAMETH
                }
                if (i === res.data.length - 1) {
                    this.setState({ MenuItem2: data_ });
                }
            }
        })
    }
    loadData = async (datasearch) => {
        let url = ""
        if (this.state.selected === "0") {
            url = "CSEXPENSE/GETCODES?Codes=" + datasearch
        } else if (this.state.selected === "1") {
            url = "CSEXPENSE/GETNAME?Name=" + datasearch
        }
        var data_ = []
        console.log(genURL(url))
        await axios.get(genURL(url), { timeout: 60000 }).then((res) => {
            if (res.data.length > 0) {
                for (let i = 0; i < res.data.length; i++) {
                    data_[i] = {
                        C0: i + 1,
                        Expensescode: res.data[i].CODE,
                        Expensesname: res.data[i].MYNAMETH
                    }
                }
            }
        }).then(_ => {
            this.setState({ MenuItem2: [...data_] });
        }).catch(error => {
            console.log(error);
        });
    }
    onKeyPress = (e) => {
        if (e.target.name === "search" && e.key === "Enter") {
            this.loadData(this.search.current.value)
        }
    }
    render() {
        return (
            <div className="popup" onKeyPress={this.onKeyPress}>
                <div className='popup_inner'>
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-at"> Expenses </i></div>
                        <div className="PopUpOtherDivH2" onClick={this.props.closePopup}><i className="fas fa-times"></i></div>
                    </div>
                    <div className="panel-body divTable" align="left">
                        <div>
                            <div className="form-inline">
                                <div className="form-group mb-2">
                                    <input type='radio' id='Choice-1' name='myRadio' value='0'
                                        checked={this.state.selected === "0"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากรหัส&nbsp;&nbsp;&nbsp;</span>
                                    <input type='radio' id='Choice-2' name='myRadio' value='1'
                                        checked={this.state.selected === "1"} onChange={(e) => this.setState({ selected: e.target.value })} /><span className="choiceSty">&nbsp;ค้นหาจากชื่อ&nbsp;</span>
                                </div>
                            </div>
                        </div>
                        <div className="input-group width-grop" >
                            <input type="text" className="form-control" placeholder="กรอกคำค้นหา" ref={this.search} name="search" />
                            <span className="input-group-addon txt-img icon"><i className="fas fa-search" onClick={() => { this.loadData(this.search.current.value) }}></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.componentDidMount() }}></i></span>
                        </div>
                        <BootstrapTable
                            data={this.state.MenuItem2}
                            options={{
                                onRowClick: this.onSelectRow,
                                noDataText: this.state.loadding
                            }}
                            hover condensed
                            height='600'
                        >
                            <TableHeaderColumn dataField='C0' isKey width="35" className="columnNumber" dataAlign="center"></TableHeaderColumn>
                            <TableHeaderColumn dataField='Expensescode' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="100" >
                                <div align="center"> รหัส </div>
                            </TableHeaderColumn>
                            <TableHeaderColumn dataField='Expensesname' columnClassName="columnAll" className="columnNumber" dataAlign="left" width="200" >
                                <div align="center"> รายการ </div>
                            </TableHeaderColumn>
                        </BootstrapTable>
                    </div>
                </div>
            </div>
        )
    }
}

